<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    // Percentual de vagas utilizadas para a barra de progresso
    slotsPercent() {
      if (this.slots.limit <= 0) {
        return 0;
      }
      return Math.min(Math.round((this.slots.used / this.slots.limit) * 100), 100);
    },
    slotsVariant() {
      if (this.slots.limit > 0 && this.slots.available == 0) {
        return "danger";
      }
      return "success";
    },
    canAdd() {
      return this.slots.available > 0;
    },
    genderLabel() {
      return this.create.user.gender == "female" ? "Feminino" : (this.create.user.gender == "male" ? "Masculino" : "");
    },
  },
  data() {
    return {
      dependents: null,

      slots: {
        limit: 0,
        used: 0,
        available: 0,
      },

      create: {
        modal: false,
        confirm: false,
        loading: false,
        user: {
          name: "",
          cpf: "",
          gender: "",
          birthday: "",
          email: "",
          cellphone: "",
          password: "",
        }
      },
    };
  },
  validations: {
    create: {
      user: {
        name: { required },
        cpf: { required, minLength: minLength(14) },
        gender: { required },
        birthday: { required, minLength: minLength(10) },
        email: { required, email },
        cellphone: { required, minLength: minLength(14) },
        password: { required, minLength: minLength(6) },
      }
    },
  },
  methods: {
    getDependents() {
      this.dependents = null;

      api
        .get('dependents')
        .then((response) => {
          if (response.data.status == 'success') {
            this.dependents = response.data.list;
            this.slots.limit = response.data.limit;
            this.slots.used = response.data.used;
            this.slots.available = response.data.available;
          }
        })
    },
    showCreate() {
      if (!this.canAdd) {
        this.$toast.error("Você atingiu o limite de dependentes do seu plano.");
        return;
      }
      this.create.modal = false;
      this.create.modal = true;
    },
    // Valida o formulário e abre o modal de confirmação dos dados
    reviewCreate() {
      this.$v.create.$touch();

      if (this.$v.create.$invalid) {
        this.$toast.error("Confira os dados informados: CPF, e-mail, data de nascimento, celular e senha (mínimo 6 caracteres).");
        return;
      }

      this.create.modal = false;
      this.create.confirm = true;
    },
    // Volta para o formulário para corrigir os dados
    backToForm() {
      this.create.confirm = false;
      this.create.modal = true;
    },
    createDependent() {
      this.create.loading = true;

      api
        .post('dependents', {
          name: this.create.user.name,
          cpf: this.create.user.cpf,
          gender: this.create.user.gender,
          birthday: this.create.user.birthday,
          email: this.create.user.email,
          cellphone: this.create.user.cellphone,
          password: this.create.user.password,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.create.user.name = "";
            this.create.user.cpf = "";
            this.create.user.gender = "";
            this.create.user.birthday = "";
            this.create.user.email = "";
            this.create.user.cellphone = "";
            this.create.user.password = "";
            this.$v.create.$reset();

            this.create.confirm = false;
            this.create.modal = false;
            this.create.loading = false;

            this.$toast.success("O dependente foi cadastrado com sucesso.");
            this.getDependents();
          } else {
            this.create.loading = false;
            this.create.confirm = false;
            this.create.modal = true;
            this.$toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error) {
            this.create.confirm = false;
            this.create.modal = false;
            this.create.loading = false;
          }
        });
    },
  },
  mounted() {
    this.getDependents();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Dependentes</h3>
        <p>Acompanhe os cadastros dos seus dependentes.</p>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>Vagas de dependentes</strong>
          <span>{{ slots.used }} de {{ slots.limit }} utilizadas</span>
        </div>
        <b-progress :value="slotsPercent" :max="100" height="12px" :variant="slotsVariant"></b-progress>
        <p class="m-0 mt-2 text-muted" v-if="slots.limit == 0">
          Seu plano não inclui vagas para dependentes.
        </p>
        <p class="m-0 mt-2 text-muted" v-else-if="slots.available > 0">
          Você ainda tem <strong>{{ slots.available }}</strong> {{ slots.available == 1 ? 'vaga disponível' : 'vagas disponíveis' }}.
        </p>
        <p class="m-0 mt-2 text-danger" v-else>
          Todas as vagas do seu plano foram utilizadas.
        </p>
      </div>
    </div>

    <button class="btn border btn-lg btn-block mb-4" v-on:click="showCreate()" :disabled="!canAdd">
      Adicionar dependente
    </button>

    <div v-if="!dependents" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="dependents && dependents.length == 0" class="card">
      <div class="card-body text-center">
        Nenhum dependente cadastrado.
      </div>
    </div>

    <div v-else>
      <div class="mb-2" v-for="(row, index) in dependents" :key="index">
        <div class="card mb-0">
          <div class="card-body d-flex justify-content-between align-items-center">
            <div>
              <img class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=35D738&color=fff&name=' + row.name" alt="" />
            </div>
            <div class="ml-3 w-75">
              <h5 class="m-0 text-dark font-size-16"><strong>{{ row.name }}</strong></h5>
              <p class="m-0 text-dark text-uppercase">{{ row.birthday }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="create.modal" modal-class="modal-right" hide-header hide-footer>
      <b-form @submit.prevent="reviewCreate">
        <h4>Adicionar novo dependente</h4>
        <p></p>
        <div class="my-5">
          <b-form-group label="Nome" label-for="name">
            <b-form-input id="name" v-model="create.user.name" type="text" required></b-form-input>
          </b-form-group>
          <b-form-group label="CPF" label-for="cpf">
            <b-form-input id="cpf" v-model="create.user.cpf" type="text" required v-mask="'###.###.###-##'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="Sexo" label-for="gender">
            <select v-model="create.user.gender" class="custom-select" required>
              <option value="male">Masculino</option>
              <option value="female">Feminino</option>
            </select>
          </b-form-group>
          <b-form-group label="Data de Nascimento" label-for="birthday">
            <b-form-input id="birthday" v-model="create.user.birthday" type="text" required v-mask="'##/##/####'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="E-mail" label-for="email">
            <b-form-input id="email" v-model="create.user.email" type="email" required inputmode="email"></b-form-input>
          </b-form-group>
          <b-form-group label="Celular" label-for="cellphone">
            <b-form-input id="cellphone" v-model="create.user.cellphone" type="text" required v-mask="'(##) #####-####'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="Senha" label-for="password">
            <b-form-input id="password" v-model="create.user.password" type="password" required></b-form-input>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" type="submit">
            Revisar dados
          </button>
          <a class="btn btn-outline-link" v-on:click="create.modal = false">Fechar</a>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="create.confirm" modal-class="modal-right" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
      <h4>Confirme os dados do dependente</h4>

      <p class="text-muted mt-2">Revise as informações abaixo antes de finalizar o cadastro.</p>

      <div class="border rounded mb-4">
        <div class="d-flex justify-content-between px-3 py-2 border-bottom">
          <span class="text-muted">Nome</span>
          <strong class="text-right">{{ create.user.name }}</strong>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 border-bottom">
          <span class="text-muted">CPF</span>
          <strong class="text-right">{{ create.user.cpf }}</strong>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 border-bottom">
          <span class="text-muted">Sexo</span>
          <strong class="text-right">{{ genderLabel }}</strong>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 border-bottom">
          <span class="text-muted">Nascimento</span>
          <strong class="text-right">{{ create.user.birthday }}</strong>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 border-bottom">
          <span class="text-muted">E-mail</span>
          <strong class="text-right">{{ create.user.email }}</strong>
        </div>
        <div class="d-flex justify-content-between px-3 py-2">
          <span class="text-muted">Celular</span>
          <strong class="text-right">{{ create.user.cellphone }}</strong>
        </div>
      </div>

      <div class="alert alert-danger mb-5" role="alert">
        <h6 class="alert-heading font-weight-bold mb-2">Atenção: este cadastro é definitivo</h6>
        <ul class="mb-2 pl-3">
          <li>O dependente <strong>não poderá ser editado</strong>.</li>
          <li>O dependente <strong>não poderá ser excluído</strong>.</li>
          <li>Ele ocupará <strong>1 vaga</strong> do seu plano.</li>
        </ul>
        <small>Se algum dado estiver errado, clique em "Voltar e corrigir".</small>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-default btn-lg mr-3" v-on:click="createDependent()" :disabled="create.loading">
          Confirmar cadastro
          <b-spinner v-if="create.loading" small class="ml-2 align-middle" variant="dark" role="status"></b-spinner>
        </button>
        <a class="btn btn-outline-link" v-on:click="backToForm()">Voltar e corrigir</a>
      </div>
    </b-modal>
  </Layout>
</template>
